import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RedirectGuard } from '../shared/services/auth/redirectGuard';
import { NotFoundComponent } from './not-found/not-found.component';
import { CasesComponent } from './cases/cases.component';
import { MyTasksComponent } from './my-tasks/my-tasks.component';
import { EvaluationsComponent } from './evaluations/evaluations.component';
import { AssessmentsComponent } from './assessments/assessments.component';
import { EvaluationDashboardComponent } from './evaluations/evaluation-dashboard/evaluation-dashboard.component';
import { EvaluationFormComponent } from './evaluations/evaluation-form/evaluation-form.component';
import { AssessmentsDashboardComponent } from './assessments/assessments-dashboard/assessments-dashboard.component';
import { FullTeamThreatAssessmentComponent } from './assessments/assessments-form/full-team-threat-assessment/full-team-threat-assessment.component';
import { TeacherStaffInterviewComponent } from './assessments/assessments-form/teacher-staff-interview/teacher-staff-interview.component';
import { AssessmentsFormComponent } from './assessments/assessments-form/assessments-form.component';
import { WitnessInterviewComponent } from './assessments/assessments-form/witness-interview/witness-interview.component';
import { StudentOfConcernInterviewComponent } from './assessments/assessments-form/student-of-concern-interview/student-of-concern-interview.component';
import { ParentInterviewComponent } from './assessments/assessments-form/parent-interview/parent-interview.component';
import { PlansComponent } from './plans/plans.component';
import { PlansDashboardComponent } from './plans/plans-dashboard/plans-dashboard.component';
import { PlansFormComponent } from './plans/plans-form/plans-form.component';
import { RmsPlanChecklistComponent } from './plans/plans-form/rms-plan-checklist/rms-plan-checklist.component';
import { RoarAssignmentFormComponent } from './plans/plans-form/roar-assignment-form/roar-assignment-form.component';
import { RmsPlanReviewScheduleComponent } from './plans/plans-form/rms-plan-review-schedule/rms-plan-review-schedule.component';
import { RmsPlanSummaryComponent } from './plans/plans-form/rms-plan-summary/rms-plan-summary.component';
import { InterventionsComponent } from './interventions/interventions.component';
import { InterventionsDashboardComponent } from './interventions/interventions-dashboard/interventions-dashboard.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { MonitoringDashboardComponent } from './monitoring/monitoring-dashboard/monitoring-dashboard.component';
import { ClosedComponent } from './closed/closed.component';
import { ClosedDashboardComponent } from './closed/closed-dashboard/closed-dashboard.component';
import { InterventionsFormComponent } from './interventions/interventions-form/interventions-form.component';
import { RoarActivityFormComponent } from './plans/plans-form/roar-activity-form/roar-activity-form.component';
import { RoarReviewFormComponent } from './plans/plans-form/roar-review-form/roar-review-form.component';
import { ThreatAssessmentSummaryComponent } from './interventions/interventions-form/threat-assessment-summary/threat-assessment-summary.component';
import { CaseClosingSummaryComponent } from './monitoring/monitoring-stage-form/case-closing-summary/case-closing-summary.component';
import { RmsRecordReviewComponent } from './monitoring/monitoring-stage-form/rms-record-review/rms-record-review.component';
import { MonitoringStageFormComponent } from './monitoring/monitoring-stage-form/monitoring-stage-form.component';
import { NsideIdentityGuard } from '../shared/services/auth/nSideIdentityGuard';
import { BuildingComponent } from './building/building.component';
import { SpinnerComponent } from './components/spinner/spinner.component';

export const routes: Routes = [
    { 
        path: '', 
        component: DashboardComponent,
        children: [
            { path: '', redirectTo: 'cases', pathMatch: 'full' },
            { path: 'cases', component: CasesComponent },
            { path: 'my-tasks', component: MyTasksComponent }
        ],
        canActivate: [NsideIdentityGuard]
    },
    { path: 'building/:buildingId/region/:regionId', component: BuildingComponent, canActivate: [NsideIdentityGuard] },
    { 
        path: 'evaluations', 
        component: EvaluationsComponent,
        children: 
        [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: EvaluationDashboardComponent },
            { path: 'form/:caseId', component: EvaluationFormComponent }
        ],
        canActivate: [NsideIdentityGuard]
    },
    { 
        path: 'assessments', 
        component: AssessmentsComponent,
        children: 
        [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: AssessmentsDashboardComponent },
            { 
                path: 'form', 
                component: AssessmentsFormComponent,
                children: [
                    { path: 'full-team-threat-assessment/:caseId', component: FullTeamThreatAssessmentComponent },
                    { path: 'teacher-staff-interview/:caseId', component: TeacherStaffInterviewComponent },
                    { path: 'witness-interview/:caseId', component: WitnessInterviewComponent },
                    { path: 'student-of-concern-interview/:caseId', component: StudentOfConcernInterviewComponent },
                    { path: 'parent-interview/:caseId', component: ParentInterviewComponent }
                ]
            }
        ],
        canActivate: [NsideIdentityGuard]
    },
    { 
        path: 'plans', 
        component: PlansComponent,
        children: 
        [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: PlansDashboardComponent },
            { 
                path: 'form', 
                component: PlansFormComponent,
                children: [
                    { path: 'rms-plan-checklist/:caseId', component: RmsPlanChecklistComponent },
                    { path: 'roar-assignment-form/:caseId/:roarId', component: RoarAssignmentFormComponent },
                    { path: 'roar-activity/:caseId/:roarId', component: RoarActivityFormComponent },
                    { path: 'roar-review/:caseId/:roarId', component: RoarReviewFormComponent },
                    { path: 'rms-plan-review-schedule/:caseId', component: RmsPlanReviewScheduleComponent },
                    { path: 'rms-plan-summary/:caseId', component: RmsPlanSummaryComponent }
                ]
            }
        ],
        canActivate: [NsideIdentityGuard]
    },
    { 
        path: 'interventions', 
        component: InterventionsComponent,
        children: 
        [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: InterventionsDashboardComponent },
            { 
                path: 'form', 
                component: InterventionsFormComponent,
                children: [
                    { path: 'threat-assessment-summary/:caseId', component: ThreatAssessmentSummaryComponent },
                    { path: 'roar-assignment-form/:caseId/:roarId', component: RoarAssignmentFormComponent },
                    { path: 'roar-activity/:caseId/:roarId', component: RoarActivityFormComponent },
                    { path: 'roar-review/:caseId/:roarId', component: RoarReviewFormComponent }
                ]
            }
        ],
        canActivate: [NsideIdentityGuard]
    },
    { 
        path: 'monitoring', 
        component: MonitoringComponent,
        children: 
        [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: MonitoringDashboardComponent },
            { 
                path: 'form', 
                component: MonitoringStageFormComponent,
                children: [
                    { path: 'rms-plan-record-of-review/:caseId', component: RmsRecordReviewComponent },
                    { path: 'roar-assignment-form/:caseId/:roarId', component: RoarAssignmentFormComponent },
                    { path: 'roar-assignment-form/:caseId/:roarId', component: RoarAssignmentFormComponent },
                    { path: 'roar-activity/:caseId/:roarId', component: RoarActivityFormComponent },
                    { path: 'roar-review/:caseId/:roarId', component: RoarReviewFormComponent },
                    { path: 'case-closing-summary/:caseId', component: CaseClosingSummaryComponent }
                ]
            }
        ],
        canActivate: [NsideIdentityGuard]
    },
    { 
        path: 'closed', 
        component: ClosedComponent,
        children: 
        [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: ClosedDashboardComponent }
        ],
        canActivate: [NsideIdentityGuard]
    },
    {
        path: 'unauthorized',
        component: SpinnerComponent,
        data: { showSidebar: false }
    },
    { 
        path: '**', 
        component: NotFoundComponent,
        data: { showSidebar: false } 
    }
];
